<div class="body-holder">
  <aside class="sidebar">
    <app-document-sidebar-header>
      <a class="btn-M btn-text icon-start" [routerLink]="urlParamsService.params.mainPath || ['/documentos', documentId]">
        <i class="fal fa-chevron-left"></i>
        {{ 'button.back' | translate }}
      </a>
    </app-document-sidebar-header>
    <main class="document-signers">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.optionalSignaturePlacement' | translate }}</div>
      </div>
      <div class="document-signers-list">
        @for (signer of signers | uniqueSigners: document?.qualified; track $index) {
          <app-signer-floating-fields-input
            [signatureAction]="signer.action"
            [identification]="signer[signer._extra.signerMainAttribute]"
            [idColor]="idColors[$index % idColors.length]"
            [attr.signer-color-id]="$index % idColors.length"
            [qualified]="document?.qualified"
            [signerQualified]="!!signer?._extra?.isQualified"
            [isCountryBR]="document?.locale?.country === 'BR'"
            [selected]="signer._extra.isSelected"
            [disabled]="isLoading"
            (addFloatingField)="setFloatingFieldFor(signer, $event, idColors[$index % idColors.length])"
          >
          </app-signer-floating-fields-input>
        }
      </div>
    </main>
    <footer class="sidebar-options">
      <button type="button" class="sidebar-options-submit" [disabled]="isLoading" (click)="updateDocument()">{{ 'button.save' | translate }}</button>
    </footer>
  </aside>
  <section class="models">
    <app-pdf-viewer
      *ngIf="!documentService.isMarkdownDocument(document)"
      [pdfUrl]="!documentService.isPastLifecycle(document) && document?.files.original"
      [enableEditFloatingFields]="true"
      [documentFooter]="document?.new_signature_style && document?.footer"
      [documentFooterType]="document?.new_signature_style && document?.footer_type"
      [qualified]="document?.qualified"
      [isNewSignatureStyle]="document?.new_signature_style"
      [document]="document"
      [class.d-none]="documentService.isPastLifecycle(document)"
      (selectedFieldChange)="selectFloatingFieldInput($event)"
      #pdfViewer
    >
    </app-pdf-viewer>
    <app-document-lifecycle-warning [(document)]="document" *ngIf="documentService.isPastLifecycle(document)"></app-document-lifecycle-warning>
  </section>
</div>

<div class="document-focus-overlay" (click)="disableFloatingFieldsSettingMode()" *ngIf="isSettingFloatingFields"></div>
